import * as classnames from 'classnames/bind'
import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Settings } from 'react-slick'
import { CardContainer } from '../../components/Card'
import { Carousel, CarouselItem } from '../../components/Carousel'
import Icon from '../../components/Icon'
import LectureItem from '../../components/LectureItem'
import homemockup1 from '../../images/common/homepage-mock/home-mockup-1.svg'
import homemockup2 from '../../images/common/homepage-mock/home-mockup-2.svg'
import homemockup3 from '../../images/common/homepage-mock/home-mockup-3.svg'
import BasicLayout from '../../layouts/BasicLayout'
import layoutSyles from '../../layouts/BasicLayout/basic-layout.scss'
import { RootState, select, store } from '../../store'
import styles from './home-page.scss'

const cx = classnames.bind({ ...styles, ...layoutSyles })

interface IProps extends Partial<ReturnType<typeof mapState>> {}

class HomePage extends React.Component<IProps> {
  public render() {
    return (
      <BasicLayout>
        {this.renderCarousel()}
        {this.renderProperty()}
        {/* {this.renderHot()} */}
        {this.renderRecommend()}
        {this.renderToBeMentor()}
        {this.renderAbout()}
        {this.renderToWish()}
      </BasicLayout>
    )
  }
  public renderCarousel = () => {
    const settings: Settings = {
      dots: false,
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000
    }
    return (
      <Carousel className={cx('carousel')} settings={settings}>
        <Link to="/explore">
          <CarouselItem>
            <div className={cx('image', 'image-mock')} />
            <div className={cx('application-form')}>
              <Link
                to="/explore"
                className={cx('btn', 'btn--primary', 'btn--lg', 'btn--fluid')}
              >
                立即體驗
              </Link>
            </div>
          </CarouselItem>
        </Link>
        <Link to="/lectures/ui-design">
          <CarouselItem>
            <div className={cx('image', 'image-ui-design')} />
            <div className={cx('application-form')}>
              <Link
                to="/lectures/ui-design"
                className={cx('btn', 'btn--primary', 'btn--lg', 'btn--fluid')}
              >
                立即體驗
              </Link>
            </div>
          </CarouselItem>
        </Link>
        <Link to="/lectures/0to1">
          <CarouselItem>
            <div className={cx('image', 'image-0to1')} />
            <div className={cx('application-form')}>
              <Link
                to="/lectures/0to1"
                className={cx('btn', 'btn--primary', 'btn--lg', 'btn--fluid')}
              >
                立即體驗
              </Link>
            </div>
          </CarouselItem>
        </Link>
        <Link to="/lectures/Design-Code">
          <CarouselItem>
            <div className={cx('image', 'image-Design-Code')} />
            <div className={cx('application-form')}>
              <Link
                to="/lectures/Design-Code"
                className={cx('btn', 'btn--primary', 'btn--lg', 'btn--fluid')}
              >
                立即體驗
              </Link>
            </div>
          </CarouselItem>
        </Link>
      </Carousel>
    )
  }
  public renderProperty = () => {
    return (
      <div className={cx('homepage-property')}>
        <div className={cx('container')}>
          <CardContainer className={cx('card')}>
            <div className={cx('property')}>
              <div className={cx('property__item')}>
                <Icon size={60} className={cx('icon')} type="leature" />
                <p className={cx('text')}>
                  <span className={cx('mobile-hidden')}>
                    觀點傳授，掌握知識精華
                  </span>
                  <span className={cx('desktop-hidden')}>掌握知識精華</span>
                </p>
              </div>
              <div className={cx('property__item')}>
                <Icon size={60} className={cx('icon')} type="live" />
                <p className={cx('text')}>
                  <span className={cx('mobile-hidden')}>
                    定時解惑，專家在線交流
                  </span>
                  <span className={cx('desktop-hidden')}>在線定時解惑</span>
                </p>
              </div>
              <div className={cx('property__item')}>
                <Icon size={60} className={cx('icon')} type="lowprice" />
                <p className={cx('text')}>
                  <span className={cx('mobile-hidden')}>
                    保存擁有，觀點不再錯過
                  </span>
                  <span className={cx('desktop-hidden')}>結束保存擁有</span>
                </p>
              </div>
            </div>
          </CardContainer>
        </div>
      </div>
    )
  }
  public renderHot = () => {
    const rootState = store.getState()
    const hotLectureIds = select.lectures.getHotLectureIds(rootState)

    return (
      <div className={cx('homepage-hot')}>
        <div className={cx('container')}>
          <div className={cx('section-title')}>
            <h3 className={cx('title')}>
              <span>近期的互動講座</span>
            </h3>
            <Link className={cx('link', 'mobile-hidden')} to="/explore">
              查看更多
            </Link>
            <h5 className={cx('subtitle', 'desktop-hidden')}>
              現在就讓專家與你深度交流
            </h5>
          </div>
          <div className={cx('lecture-group')}>
            <div className={cx('row')}>
              {hotLectureIds
                ? hotLectureIds.map(hotLectureId => (
                    <div
                      key={hotLectureId}
                      className={cx('col-md-6', 'col-lg-4')}
                    >
                      <LectureItem lectureId={hotLectureId} />
                    </div>
                  ))
                : '載入中'}
            </div>
          </div>
          <Link
            className={cx(
              'desktop-hidden',
              'btn',
              'btn--lg',
              'btn--primary',
              'btn--line'
            )}
            to="/explore"
          >
            查看更多近期講座
          </Link>
        </div>
      </div>
    )
  }
  public renderRecommend = () => {
    const { recommends } = this.props
    return (
      <div className={cx('homepage-recommend')}>
        <div className={cx('container')}>
          <div className={cx('section-title')}>
            <h3 className={cx('title')}>
              <span>最新的互動講座</span>
            </h3>
            <Link className={cx('link', 'mobile-hidden')} to="/explore">
              查看更多
            </Link>
            <h5 className={cx('subtitle', 'desktop-hidden')}>
              預購5折以上優惠
            </h5>
          </div>
          <div className={cx('recommend-group')}>
            <div className={cx('row')}>
              {recommends
                ? recommends.map(recommend => (
                    <div
                      key={recommend.lectureId}
                      className={cx('col-md-6', 'col-lg-4')}
                    >
                      <LectureItem lectureId={recommend.lectureId} />
                    </div>
                  ))
                : '載入中'}
            </div>
            <Link
              className={cx(
                'desktop-hidden',
                'btn',
                'btn--lg',
                'btn--primary',
                'btn--line'
              )}
              to="/explore"
            >
              查看更多最新講座
            </Link>
          </div>
        </div>
      </div>
    )
  }
  public renderToBeMentor = () => {
    return (
      <div className={cx('homepage-tobementor')}>
        <div className={cx('container')}>
          <div className={cx('card')}>
            <div className={cx('card__inner')}>
              <h4 className={cx('title')}>成為講師、獨家合作。</h4>
              <p className={cx('subtitle')}>
                讓專業輕鬆上架、在零碎時間增加收入
              </p>
              <a
                href="/recruit"
                target="_blank"
                className={cx('btn', 'btn--xs', 'btn--primary')}
              >
                了解詳情
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
  public renderAbout = () => {
    return (
      <div className={cx('index-about')}>
        <div className={cx('container')}>
          <h1 className={cx('title-about')}>關於 Qraft</h1>
          <div className={cx('row', 'align-items-center', 'item-container')}>
            <div className={cx('col-md-6')}>
              <div className={cx('svg-container')}>
                <img src={homemockup1} alt="" />
              </div>
            </div>
            <div className={cx('col-md-6')}>
              <div className={cx('text-container')}>
                <h3 className={cx('title', 'heading-3')}>
                  好的知識觀點都值得被你收藏
                </h3>
                <p className={cx('heading-5')}>
                  Qraft 上架每個有用的知識，領取每個專家的私藏秘笈
                  <br className={cx('mobile-hidden')} />
                  創造最好的知識交流空間，成為隨身攜帶的知識圖鑑
                </p>
              </div>
            </div>
          </div>
          <div className={cx('row', 'align-items-center', 'item-container')}>
            <div
              className={cx('col-md-6', 'order-2', 'order-sm-2', 'order-md-1')}
            >
              <div className={cx('text-container')}>
                <h3 className={cx('title', 'heading-3')}>專家就在你身邊</h3>
                <p className={cx('heading-5')}>
                  不讓思維迷了路，專家保證回覆
                  <br className={cx('mobile-hidden')} />
                  與專家即時互動，口語化的問答一次搞懂
                </p>
              </div>
            </div>
            <div
              className={cx('col-md-6', 'order-1', 'order-sm-1', 'order-md-2')}
            >
              <div className={cx('svg-container')}>
                <img src={homemockup2} alt="" />
              </div>
            </div>
          </div>
          <div className={cx('row', 'align-items-center', 'item-container')}>
            <div
              className={cx('col-md-6', 'order-2', 'order-sm-2', 'order-md-2')}
            >
              <div className={cx('text-container')}>
                <h3 className={cx('title', 'heading-3')}>傳授系統化知識</h3>
                <p className={cx('heading-5')}>
                  長時間的搜索觀點，但真實且可信嗎？
                  <br className={cx('mobile-hidden')} />
                  不如讓專家親自傳授觀點，有效且省下您大量時間成本。
                </p>
              </div>
            </div>
            <div
              className={cx('col-md-6', 'order-1', 'order-sm-1', 'order-md-1')}
            >
              <div className={cx('svg-container')}>
                <img src={homemockup3} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  public renderToWish = () => {
    return (
      <div className={cx('towish')}>
        <div className={cx('container')}>
          <div className={cx('inner')}>
            <h4 className={cx('title')}>找不到你想要的主題嗎？</h4>
            <p className={cx('subtitle')}>留下你的願望，我們幫你實現</p>
            <a
              href="https://louissyue.typeform.com/to/nLtnv7"
              target="_blank"
              className={cx('btn', 'btn--md', 'btn--primary', 'btn--shadow')}
            >
              前往許願
            </a>
          </div>
        </div>
      </div>
    )
  }
}

const mapState = ({ recommends, lectures }: RootState) => ({
  recommends,
  lectures
})

export default connect(mapState)(HomePage)



// WEBPACK FOOTER //
// ./src/pages/HomePage/index.tsx